import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailSynopsisText = styled.div<React.CSSProperties>`
  color: ${Colors['text']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
`;

export default DetailSynopsisText;
